(() => {
const PRODUCT_ID = "10790403342670";

function initDirectCheckout() {
const button = document.querySelector(
`[data-direct-checkout-knee-sleeve][data-product-id="${PRODUCT_ID}"]`
);

if (!button || button.dataset.directCheckoutReady === "true") return;

button.dataset.directCheckoutReady = "true";

const label = button.querySelector(".button__label");
const errorMessage = document.querySelector("[data-direct-checkout-error]");

function showError(message) {
if (!errorMessage) return;
errorMessage.textContent = message;
errorMessage.hidden = false;
}

button.addEventListener("click", async () => {
const form = document.getElementById(button.dataset.formId);
const variantInput =
form?.querySelector("input[name='id'].product-variant-id") ||
form?.querySelector("input[name='id']");

const variantId = variantInput?.value;
const storefrontToken = button.dataset.storefrontToken;
const storefrontEndpoint = button.dataset.storefrontEndpoint;

if (!variantId || !storefrontToken || !storefrontEndpoint) {
showError("Couldn’t open secure checkout. Please use Add to Cart.");
return;
}

const originalLabel = label?.textContent || "Buy Now, Secure Checkout";

button.disabled = true;
if (label) label.textContent = "Opening secure checkout…";
if (errorMessage) errorMessage.hidden = true;

const query = `
mutation CartCreate($input: CartInput!) {
cartCreate(input: $input) {
cart {
checkoutUrl
}
userErrors {
field
message
}
}
}
`;

const variables = {
input: {
lines: [
{
merchandiseId: `gid://shopify/ProductVariant/${variantId}`,
quantity: 1
}
]
}
};

try {
const response = await fetch(storefrontEndpoint, {
method: "POST",
headers: {
"Content-Type": "application/json",
"X-Shopify-Storefront-Access-Token": storefrontToken
},
body: JSON.stringify({ query, variables })
});

if (!response.ok) {
throw new Error(`Storefront API returned ${response.status}.`);
}

const result = await response.json();
const cartCreate = result?.data?.cartCreate;
const userErrors = cartCreate?.userErrors || [];
const checkoutUrl = cartCreate?.cart?.checkoutUrl;

if (userErrors.length > 0) {
throw new Error(userErrors.map((error) => error.message).join(", "));
}

if (!checkoutUrl) {
throw new Error("Shopify did not return a checkout URL.");
}

window.location.assign(checkoutUrl);
} catch (error) {
console.error("Direct checkout failed:", error);

button.disabled = false;
if (label) label.textContent = originalLabel;

showError("Couldn’t open secure checkout. Please try again or use Add to Cart.");
}
});
}

document.addEventListener("DOMContentLoaded", initDirectCheckout);
document.addEventListener("shopify:section:load", initDirectCheckout);
})();